// spacing

export const standardWidth = 700;

//232 is the exact value (px) but we have to add the spacing above and below of this component in explore (like the search bar and the vertical margins)
export const standarHeroAssetHeight = 300;
